import request from "@/router/axios";

// 获取应急标签列表（父级，分页）
export const getParentList = (data) => {
  return request({
    url: "/api/produce/emergency-tag/select/page",
    method: "post",
    data,
  });
};

// 获取应急标签列表（通用）
export const getList = (data) => {
  return request({
    url: "/api/produce/emergency-tag/select/page",
    method: "post",
    data,
  });
};

// 获取子级应急标签列表
export const getChildList = (current, size, parentId, params) => {
  return request({
    url: "/api/produce/emergency-tag/select/page",
    method: "post",
    data: {
      ...params,
      parentId,
      page: current,
      size: size,
    },
  });
};

// 获取应急标签列表（去重分页）
export const getDistinctList = (data) => {
  return request({
    url: "/api/produce/emergency-tag/select/distinct/page",
    method: "post",
    data,
  });
};

// 获取应急标签详情（通用）
export const getDict = (id) => {
  return request({
    url: "/api/produce/emergency-tag/select/id",
    method: "get",
    params: { id },
  });
};

// 获取应急标签详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/emergency-tag/select/id",
    method: "get",
    params: { id },
  });
};

// 获取应急标签树形结构
export const getDictTree = () => {
  return request({
    url: "/api/produce/emergency-tag/select/page",
    method: "post",
    data: {
      page: 1,
      size: 1000, // 获取所有数据用于构建树
    },
  });
};

// 新增应急标签
export const add = (data) => {
  return request({
    url: "/api/produce/emergency-tag/insert",
    method: "post",
    data,
  });
};

// 更新应急标签
export const update = (data) => {
  return request({
    url: "/api/produce/emergency-tag/update",
    method: "post",
    data,
  });
};

// 删除应急标签（单个）
export const remove = (id) => {
  return request({
    url: "/api/produce/emergency-tag/delete/id",
    method: "get",
    params: { id },
  });
};

// 批量删除应急标签
export const removeBatch = (ids) => {
  return request({
    url: "/api/produce/emergency-tag/delete/ids",
    method: "get",
    params: { ids },
  });
};
